module.exports = __webpack_public_path__ + "img/violet_055.b07c2742.png";